<template>
	<div class="report_row page">
		<div class="sub_header">{{$t('report.paper.expert_opinion')}}</div>
		<div class="text_area">
			{{expertOpinionContext}}
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  name: 'ExpertOpinionSection',
  data() {
    return {
      expertOpinionContext: ''
    }
  },
  methods: {
    ...mapGetters(['getReport']),
  },
  mounted() {
    this.expertOpinionContext = this.getReport().expertOpinionData;
  },
  created() {
    this.unsubscribe = this.$store.subscribe((_mutation, state) => {
      this.expertOpinionContext = state.report.expertOpinionData;
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
}
</script>